import CustomParamsControl from '@bingads-webui-component-legacy/form/view/control/custom-params';

export default {
  control: CustomParamsControl,
};
